import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';

import { apiLogsStore } from '@/features/request-logger/api-logs.store';
import { RequestLogger } from '@/features/request-logger/request-logger';
import { ApiLogsInterceptorProvider } from '@/providers/ApiLogsInterceptorProvider';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/debug/')({
  beforeLoad() {
    if (userStore.isInternalUser) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  useEffect(() => {
    apiLogsStore.setPageActive(true);
    return () => {
      apiLogsStore.setPageActive(false);
      apiLogsStore.trimToLimit();
    };
  }, []);

  return (
    <ApiLogsInterceptorProvider>
      <RequestLogger />
    </ApiLogsInterceptorProvider>
  );
}
